document.addEventListener('change', event => {
 if (!event.target.matches('[data-variant-select]')) return;
 const option = event.target.selectedOptions[0];
 const section = event.target.closest('.product-info');
 const button = section.querySelector('[data-add-button]');
 section.querySelector('[data-product-price]').textContent = option.dataset.price;
 button.disabled = option.dataset.available !== 'true';
 button.textContent = button.disabled ? 'Sold out' : 'Add to bag';
 const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
});
document.addEventListener('keydown',event=>{if(event.key==='Escape') document.querySelectorAll('.menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
document.addEventListener('click',event=>{document.querySelectorAll('.menu[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});});

document.addEventListener('click',event=>{
 const globe=event.target.closest('[data-globe-toggle]');
 if(!globe)return;
 const paused=globe.classList.toggle('is-paused');
 globe.setAttribute('aria-pressed',String(paused));
 globe.setAttribute('aria-label',paused?'Resume globe animation':'Pause globe animation');
});
